import React from 'react'
import styled from 'styled-components'

const fileTypeIcons = {
    wordDocument: (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect y="0.224976" width="24" height="24" rx="3" fill="#0072FF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 5.82498C4 4.94132 4.63207 4.22498 5.41176 4.22498H18.5882C19.3679 4.22498 20 4.94132 20 5.82498C20 6.70863 19.3679 7.42498 18.5882 7.42498H5.41176C4.63207 7.42498 4 6.70863 4 5.82498ZM4 12.225C4 11.3413 4.63207 10.625 5.41176 10.625H15.2941C16.0738 10.625 16.7059 11.3413 16.7059 12.225C16.7059 13.1086 16.0738 13.825 15.2941 13.825H5.41176C4.63207 13.825 4 13.1086 4 12.225ZM4 18.625C4 17.7413 4.63207 17.025 5.41176 17.025H8.70588C9.48558 17.025 10.1176 17.7413 10.1176 18.625C10.1176 19.5086 9.48558 20.225 8.70588 20.225H5.41176C4.63207 20.225 4 19.5086 4 18.625Z"
                fill="white"
            />
        </svg>
    ),
    pdf: (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect y="0.125" width="24" height="24" rx="3" fill="#FF3E4C" />
            <path
                d="M18.1781 15.485H16.4258V8.76501H21V10.1388H18.1781V11.671H20.7278V12.9796H18.1781V15.485Z"
                fill="white"
            />
            <path
                d="M9.43833 8.76501H11.8639C13.7786 8.76501 14.8004 9.91063 14.8004 12.0575C14.8004 14.3161 13.7977 15.485 11.8639 15.485H9.43833V8.76501ZM11.1907 10.1388V14.1112H11.5965C12.5849 14.1112 13.0146 13.4965 13.0146 12.0901C13.0146 10.7722 12.5563 10.1388 11.5965 10.1388H11.1907Z"
                fill="white"
            />
            <path
                d="M3 8.76501H5.69776C7.23524 8.76501 8.18065 9.67312 8.18065 11.1494C8.18065 12.607 7.18749 13.5151 5.59271 13.5151H4.75235V15.485H3V8.76501ZM4.75235 10.0643V12.2158H5.2537C6.05587 12.2158 6.4092 11.8852 6.4092 11.1401C6.4092 10.395 6.05587 10.0643 5.2537 10.0643H4.75235Z"
                fill="white"
            />
        </svg>
    ),
    spreadsheet: (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect y="0.849976" width="24" height="24" rx="3" fill="#00C650" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.60696 4.84998H15.393C16.037 4.84997 16.5685 4.84996 17.0015 4.88533C17.4511 4.92207 17.8645 5.00092 18.2528 5.19876C18.8549 5.50555 19.3444 5.99509 19.6512 6.59721C19.8491 6.98547 19.9279 7.39884 19.9646 7.84852C20 8.28147 20 8.81295 20 9.45692V16.243C20 16.887 20 17.4185 19.9646 17.8514C19.9279 18.3011 19.8491 18.7145 19.6512 19.1027C19.3444 19.7049 18.8549 20.1944 18.2528 20.5012C17.8645 20.699 17.4511 20.7779 17.0015 20.8146C16.5685 20.85 16.037 20.85 15.3931 20.85H8.60694C7.96297 20.85 7.43149 20.85 6.99854 20.8146C6.54886 20.7779 6.1355 20.699 5.74723 20.5012C5.14511 20.1944 4.65557 19.7049 4.34878 19.1027C4.15095 18.7145 4.0721 18.3011 4.03536 17.8514C3.99998 17.4185 3.99999 16.887 4 16.243V9.45694C3.99999 8.81296 3.99998 8.28147 4.03536 7.84852C4.0721 7.39884 4.15095 6.98548 4.34878 6.59721C4.65557 5.99509 5.14511 5.50555 5.74723 5.19876C6.1355 5.00092 6.54886 4.92207 6.99854 4.88533C7.4315 4.84996 7.96298 4.84997 8.60696 4.84998ZM5.6 11.25V14.45H11.2V11.25H5.6ZM11.2 9.64998H5.6V9.48998C5.6 8.80471 5.60062 8.33888 5.63004 7.97881C5.6587 7.62807 5.71064 7.44871 5.77439 7.32359C5.92779 7.02253 6.17256 6.77776 6.47362 6.62437C6.59874 6.56061 6.7781 6.50867 7.12883 6.48002C7.4889 6.4506 7.95474 6.44998 8.64 6.44998H11.2V9.64998ZM12.8 11.25V14.45H18.4V11.25H12.8ZM18.4 9.64998H12.8V6.44998H15.36C16.0453 6.44998 16.5111 6.4506 16.8712 6.48002C17.2219 6.50867 17.4013 6.56061 17.5264 6.62437C17.8274 6.77776 18.0722 7.02253 18.2256 7.32359C18.2894 7.44871 18.3413 7.62807 18.37 7.97881C18.3994 8.33888 18.4 8.80471 18.4 9.48998V9.64998ZM18.4 16.05H12.8V19.25H15.36C16.0453 19.25 16.5111 19.2494 16.8712 19.2199C17.2219 19.1913 17.4013 19.1393 17.5264 19.0756C17.8274 18.9222 18.0722 18.6774 18.2256 18.3764C18.2894 18.2512 18.3413 18.0719 18.37 17.7211C18.3994 17.3611 18.4 16.8952 18.4 16.21V16.05ZM11.2 19.25V16.05H5.6V16.21C5.6 16.8952 5.60062 17.3611 5.63004 17.7211C5.6587 18.0719 5.71064 18.2512 5.77439 18.3764C5.92779 18.6774 6.17256 18.9222 6.47362 19.0756C6.59874 19.1393 6.7781 19.1913 7.12883 19.2199C7.4889 19.2494 7.95474 19.25 8.64 19.25H11.2Z"
                fill="white"
            />
        </svg>
    ),
    image: (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect y="0.75" width="24" height="24" rx="2" fill="#A140FF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.57559 4.75H15.4244C16.0774 4.74999 16.6114 4.74998 17.0454 4.78544C17.4946 4.82215 17.9003 4.90044 18.2792 5.0935C18.8722 5.39564 19.3544 5.87776 19.6565 6.47076C19.8496 6.84966 19.9279 7.25538 19.9646 7.7046C20 8.13861 20 8.67264 20 9.32562V16.1744C20 16.8274 20 17.3614 19.9646 17.7954C19.9279 18.2446 19.8496 18.6503 19.6565 19.0292C19.3544 19.6222 18.8722 20.1044 18.2792 20.4065C17.9003 20.5996 17.4946 20.6779 17.0454 20.7146C16.6114 20.75 16.0774 20.75 15.4244 20.75H8.57562C8.55832 20.75 8.54111 20.75 8.52397 20.75L7.876 20.75C7.6557 20.75 7.44425 20.7501 7.27503 20.7351C7.26815 20.7345 7.26097 20.7338 7.25351 20.7331C7.14897 20.7284 7.0494 20.7223 6.9546 20.7146C6.50538 20.6779 6.09966 20.5996 5.72076 20.4065C5.12776 20.1044 4.64564 19.6222 4.3435 19.0292C4.15044 18.6503 4.07215 18.2446 4.03544 17.7954C3.99998 17.3614 3.99999 16.8274 4 16.1744V9.3256C3.99999 8.67262 3.99998 8.1386 4.03544 7.7046C4.07215 7.25538 4.15044 6.84966 4.3435 6.47076C4.64564 5.87776 5.12776 5.39564 5.72076 5.0935C6.09966 4.90044 6.50538 4.82215 6.9546 4.78544C7.3886 4.74998 7.92262 4.74999 8.57559 4.75ZM18.5455 13.4185L16.6438 11.5168C16.4985 11.3715 16.3602 11.2332 16.2342 11.1261C16.0967 11.0094 15.9267 10.8879 15.7068 10.8164C15.3984 10.7162 15.0662 10.7162 14.7579 10.8164C14.5379 10.8879 14.368 11.0094 14.2305 11.1261C14.1044 11.2332 13.9661 11.3715 13.8208 11.5168L6.91285 18.4248C6.75706 18.5805 6.60753 18.73 6.49848 18.8603C6.45422 18.9132 6.39257 18.9895 6.33587 19.0866C6.03728 18.9229 5.79445 18.673 5.6395 18.3689C5.56834 18.2292 5.51451 18.0362 5.48516 17.677C5.45511 17.3092 5.45455 16.8348 5.45455 16.1439V9.35606C5.45455 8.66521 5.45511 8.19081 5.48516 7.82305C5.51451 7.46377 5.56834 7.27078 5.6395 7.13111C5.8022 6.8118 6.0618 6.5522 6.38111 6.3895C6.52078 6.31834 6.71377 6.26451 7.07305 6.23516C7.44081 6.20511 7.91521 6.20455 8.60606 6.20455H15.3939C16.0848 6.20455 16.5592 6.20511 16.927 6.23516C17.2862 6.26451 17.4792 6.31834 17.6189 6.3895C17.9382 6.5522 18.1978 6.8118 18.3605 7.13111C18.4317 7.27078 18.4855 7.46377 18.5148 7.82305C18.5449 8.19081 18.5455 8.66521 18.5455 9.35606V13.4185ZM6.82828 9.92172C6.82828 8.62748 7.87747 7.57828 9.17172 7.57828C10.466 7.57828 11.5152 8.62748 11.5152 9.92172C11.5152 11.216 10.466 12.2652 9.17172 12.2652C7.87748 12.2652 6.82828 11.216 6.82828 9.92172Z"
                fill="white"
            />
        </svg>
    ),
    website: (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.16699 10.0003H18.8337M2.16699 10.0003C2.16699 14.6027 5.89795 18.3337 10.5003 18.3337M2.16699 10.0003C2.16699 5.39795 5.89795 1.66699 10.5003 1.66699M18.8337 10.0003C18.8337 14.6027 15.1027 18.3337 10.5003 18.3337M18.8337 10.0003C18.8337 5.39795 15.1027 1.66699 10.5003 1.66699M10.5003 1.66699C12.5847 3.94895 13.7693 6.91035 13.8337 10.0003C13.7693 13.0903 12.5847 16.0517 10.5003 18.3337M10.5003 1.66699C8.41593 3.94895 7.23137 6.91035 7.16699 10.0003C7.23137 13.0903 8.41593 16.0517 10.5003 18.3337"
                stroke="#6A7383"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
}

const fileTypeMap = new Map([
    ['pdf', fileTypeIcons.pdf],
    ['doc', fileTypeIcons.wordDocument],
    ['docx', fileTypeIcons.wordDocument],
    ['xls', fileTypeIcons.spreadsheet],
    ['xlsx', fileTypeIcons.spreadsheet],
    ['xlsm', fileTypeIcons.spreadsheet],
    ['jpg', fileTypeIcons.image],
    ['jpeg', fileTypeIcons.image],
    ['png', fileTypeIcons.image],
    ['tif', fileTypeIcons.image],
    ['gif', fileTypeIcons.image],
    ['bmp', fileTypeIcons.image],
    ['heif', fileTypeIcons.image],
    ['html', fileTypeIcons.website],
])

const FileTypeIconContainer = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    svg {
        width: 18px;
        height: 18px;
    }
`

export const FileTypeIcon = ({ fileName }: { fileName: string }) => {
    let fileType: string | undefined

    if (URL.canParse(fileName)) {
        fileType = 'html'
    } else {
        fileType = fileName.split('.').pop()?.toLocaleLowerCase()
    }

    return (
        <FileTypeIconContainer>
            {fileType ? fileTypeMap.get(fileType) || '' : ''}
        </FileTypeIconContainer>
    )
}
